

import {
    UserSummaryFieldModule
} from '../../../../../account/modules/user/api/component/user-summary-field/user-summary-field.module';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SummaryModule } from '../../../../../core/component/summary/summary.module';
import { SummaryFieldModule } from '../../../../../core/component/summary-field/summary-field.module';
import {
    DatetimeSummaryFieldModule
} from '../../../../../core/component/date/datetime-summary-field/datetime-summary-field.module';
import { DatetimeLabelModule } from '../../../../../core/component/date/datetime-label/datetime-label.module';
import { WorkflowTaskSummaryComponent } from './workflow-task-summary.component';
import { NgModule } from '@angular/core';
import {
    WorkflowTaskStatusLabelModule
} from '../workflow-task-status-label/workflow-task-status-label.module';
import {BadgeModule} from "../../../../../core/component/badge/badge.module";
import {
    CommentSummaryFieldModule
} from "../../../../../core/component/comment/comment-summary-field/comment-summary-field.component";
import {
    PartnerSummaryFieldModule
} from "../../../../../partner/common/api/component/partner-summary-field/partner-summary-field.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        SummaryModule,
        SummaryFieldModule,
        DatetimeSummaryFieldModule,
        DatetimeLabelModule,
        UserSummaryFieldModule,
        WorkflowTaskStatusLabelModule,
        BadgeModule,
        CommentSummaryFieldModule,
        PartnerSummaryFieldModule,
    ],
    declarations: [
        WorkflowTaskSummaryComponent,
    ],
    exports: [
        WorkflowTaskSummaryComponent
    ],
})
export class WorkflowTaskSummaryModule {
}
